// extracted by mini-css-extract-plugin
export default {"inputContainer":"Register_inputContainer__rHgtt","inputText":"Register_inputText__+O2Bg"};